import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { orderStatusService } from '../services/orderStatus.service';

// Async thunks
export const fetchOrderStatuses = createAsyncThunk(
  'orderStatus/fetchOrderStatuses',
  async (_, { rejectWithValue }) => {
    try {
      const response = await orderStatusService.getOrderStatuses();
      
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Erreur lors de la récupération des statuts de commande');
    }
  }
);

export const fetchActiveOrderStatuses = createAsyncThunk(
  'orderStatus/fetchActiveOrderStatuses',
  async (_, { rejectWithValue }) => {
    try {
      return await orderStatusService.getActiveOrderStatuses();
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Erreur lors de la récupération des statuts actifs');
    }
  }
);

// Initial state
const initialState = {
  statuses: [],
  loading: false,
  error: null,
};

// Slice
const orderStatusSlice = createSlice({
  name: 'orderStatus',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch order statuses
      .addCase(fetchOrderStatuses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderStatuses.fulfilled, (state, action) => {
        state.loading = false;
        state.statuses = Array.isArray(action.payload) ? action.payload : (action.payload?.items || []);
      })
      .addCase(fetchOrderStatuses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch active order statuses
      .addCase(fetchActiveOrderStatuses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveOrderStatuses.fulfilled, (state, action) => {
        state.loading = false;
        state.statuses = Array.isArray(action.payload) ? action.payload : (action.payload?.items || []);
      })
      .addCase(fetchActiveOrderStatuses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = orderStatusSlice.actions;

export default orderStatusSlice.reducer;
